module.exports = __webpack_public_path__ + "static/media/magnifying-glass-doubt.204565f6.jpg";